import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import { enableCacheDebugging } from './utils/cacheManager'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(VueSweetalert2)
app.use(router)

// Get initial dark mode value from auth store
import { useAuthStore } from './stores/auth'
const authStore = useAuthStore(pinia)
if (authStore.isDarkMode) {
  document.documentElement.classList.add('dark')
} else {
  document.documentElement.classList.remove('dark')
}

// Initialize PWA service worker with update handling
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration);

        // Check for service worker updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                console.log('New service worker available');
                // Optionally notify user about update
                // You could show a toast notification here
              }
            });
          }
        });

        // Check for updates every hour
        setInterval(() => {
          registration.update();
        }, 60 * 60 * 1000); // 1 hour

      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });

  // Listen for navigation messages from service worker
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data.type === 'NAVIGATE_TO') {
      // Use Vue Router to navigate to the URL
      router.push(event.data.url);
    }
  });

  // Handle service worker updates when page becomes visible
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden && navigator.serviceWorker.controller) {
      // Check for updates when user returns to app
      navigator.serviceWorker.getRegistration().then((registration) => {
        if (registration) {
          registration.update();
        }
      });
    }
  });
}

// Enable cache debugging in development
if (import.meta.env.DEV) {
  enableCacheDebugging();
}

app.mount('#app')
